export const DOG_TAB = 'DOG_TAB';
export const EVENT_TAB = 'EVENT_TAB';
export const FOLLOWERS_TAB = 'FOLLOWERS_TAB';
export const FOLLOWING_TAB = 'FOLLOWING_TAB';
export const DOG_PROFILE_PATH = 'https://s3.ca-central-1.amazonaws.com/assets.pawcker/uploads/dogProfiles/';
export const USER_PROFILE_PATH = 'https://s3.ca-central-1.amazonaws.com/assets.pawcker/uploads/userProfiles/';
